export const VUOROT_JA_VAPAAT_LIST_ID = 'VuorotJaVapaatList'
export const VUOROT_JA_VAPAAT_DATA_SOURCE_ID = 'VuorotJaVapaatDataSource'
export const TOTEUMAT_LIST_ID = 'ToteumaList'
